/** The API clamps a page at this many rows silently, so any caller has to state the ceiling. */
export const MAX_ROWS = 200;
